import React, { useEffect } from "react";
import { Suspense, useState, Fragment } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "./Navbar";
import Header from "./Header";
import Auth from "./pages/login";
import CircularProgress from "./components/modals/Loading";
import PaymentPage from "./pages/PaymentPage";
import PaymentResult from "./pages/PaymentResult";
import { routesArray, adminRoutesArray } from "utils/routesArray";
import { useNavigate } from "react-router-dom";

const DefaultComponent = () => {
  const [collapsed, setCollapsed] = useState(true);
  const authData = useSelector((state) => state.auth.authData);
  const navigate = useNavigate();

  useEffect(() => {
    const allowedOrigins = [
      "https://aibilling.services.orcicare.com",
      "https://aibilling-test.services.orcicare.com",
    ];

    const handleMessage = (event) => {
      if (!allowedOrigins.includes(event.origin)) return;

      const { type, payload } = event.data || {};

      if (type !== "AIBilling:openChargeEntry") return;

      console.log("Opening CE from AI", payload);

      navigate("/dashboard", {
        state: {
          openChargeEntry: payload,
        },
      });
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, [navigate]);

  const isLoggedIn = () => {
    if (authData) {
      return new Date() - new Date(authData.loginTime) < 3600000;
    }
    return false;
  };

  if (!isLoggedIn()) return <Navigate to="/login" />;
  return (
    <Fragment>
      <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Header collapsed={collapsed} setCollapsed={setCollapsed} />
      <main className="main-container">
        <Suspense fallback={<CircularProgress />}>
          <Routes>
            {routesArray.map(({ path, component }) => (
              <Route key={path} path={path} Component={component} />
            ))}
            {authData?.isAdmin &&
              adminRoutesArray.map(({ path, component }) => (
                <Route key={path} path={path} Component={component} />
              ))}
          </Routes>
        </Suspense>
      </main>
    </Fragment>
  );
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Auth />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/payment-result" element={<PaymentResult />} />
      <Route path="/*" element={<DefaultComponent />} />
    </Routes>
  );
};

export default AppRoutes;
